export default __webpack_public_path__ + "static/jeremy-hunt-8a71352a4be41cdb375eb8f0dc83e004.jpeg";